// extracted by mini-css-extract-plugin
export default {"top":"Footer_top__2GlSA","bottom":"Footer_bottom__KaBno","first":"Footer_first__hWXrv","fourthImg":"Footer_fourthImg__Yu40N","txt":"Footer_txt__TheAh"};